import src from "IMAGE";
export default { src, width: 291, height: 76, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ANl2YePyj3n/9aCN//Wgjv/1n4z/9aCN//KPef/ZdmHjALZbSMvXcl7t2n9t7tqAbu7Zf23u2X5s7tZxXe21WkjL3iUr1VLOv2EAAAAASUVORK5CYII="};
